import React, { useState } from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingServiceInfoForm } from '../../forms';
import config from '../../config';

import css from './EditListingServiceInfoPanel.module.css';

const EditListingServiceInfoPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;


  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { publicData, price } = currentListing.attributes;
  const publicDataConsultationPrice = publicData.consultationPrice;
  const publicDataBrainstormPrice = publicData.brainstormPrice;
  const publicDataMockPrice = publicData.mockPrice;
  const publicDataPersonalStatementEditingPrice = publicData.personalStatementEditingPrice;
  const publicDataSecondaryStatementEditingPrice = publicData.secondaryStatementEditingPrice;

  const [consultationPriceHook, setConsultationPrice] = useState(publicDataConsultationPrice ? `${(parseFloat(publicDataConsultationPrice) * 0.8).toFixed(2)}` : "");
  const [brainstormPriceHook, setBrainstormPrice] = useState(publicDataBrainstormPrice ? `${(parseFloat(publicDataBrainstormPrice) * 0.8).toFixed(2)}` : "");
  const [mockPriceHook, setMockPrice] = useState(publicDataMockPrice ? `${(parseFloat(publicDataMockPrice) * 0.8).toFixed(2)}` : "");
  const [personalStatementEditingPriceHook, setPersonalStatementEditingPrice] = useState(publicDataPersonalStatementEditingPrice ? `${(parseFloat(publicDataPersonalStatementEditingPrice) * 0.8).toFixed(2)}` : "");
  const [secondaryStatementEditingPriceHook, setSecondaryStatementEditingPrice] = useState(publicDataSecondaryStatementEditingPrice ? `${(parseFloat(publicDataSecondaryStatementEditingPrice) * 0.8).toFixed(2)}` : "");

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingServiceInfoPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingServiceInfoPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingServiceInfoPanel.createListingTitle" />
  );

  
  const serviceOptions = [
    { key: 'consultation', label: 'Consultation' },
    { key: 'personalStatementBrainstorm', label: 'Personal statement brainstorm' },
    { key: 'personalStatementEditing', label: 'Personal statement editing' },
    { key: 'secondaryStatementEditing', label: 'Secondary statement editing' },
    { key: 'mockInterview', label: 'Mock interview' },
  ]
  const mockOptions = findOptionsForSelectFilter('mock', config.custom.filters);
  const brainstormOptions = findOptionsForSelectFilter('brainstorm', config.custom.filters);
  const personalStatementEditingOptions = findOptionsForSelectFilter('personalStatementEditing', config.custom.filters);
  const secondaryStatementEditingOptions = findOptionsForSelectFilter('secondaryStatementEditing', config.custom.filters);
  const letterOfIntentOptions = findOptionsForSelectFilter('letterOfIntent', config.custom.filters);
// publicData.consultation && publicData.brainstorm && publicData.mock && publicData.editing
  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>

      <br/>

      <p>It’s time to select the services that you want to offer! Please follow these instructions in order to ensure that your profile will be verified and display the correct information: </p>
      <p>1. Click the service to find out more about it</p>
      <p>2. Answer the prompts and put the price that you want to charge </p>
      <p>3. Repeat steps 1 and 2 for every service that you would like to offer</p>
      <p><strong>Note: it will flash red if you start filling out a service and there are missing fields!</strong></p>
      
      <br/><br/>
      <EditListingServiceInfoForm
        className={css.form}
        initialValues={{  service: publicData.service,
                          //consultation: publicData.consultation,
                          brainstorm: publicData.brainstorm,
                          mock: publicData.mock,
                          personalStatementEditing: publicData.personalStatementEditing,
                          secondaryStatementEditing: publicData.secondaryStatementEditing,
                          letterOfIntent: publicData.letterOfIntent,
                          consultationPrice: publicData.consultationPrice,
                          brainstormPrice: publicData.brainstormPrice,
                          mockPrice: publicData.mockPrice,
                          personalStatementEditingPrice: publicData.personalStatementEditingPrice,
                          secondaryStatementEditingPrice: publicData.secondaryStatementEditingPrice,
                          letterOfIntentPrice: publicData.letterOfIntentPrice,
                        }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const {  service, brainstorm, mock, personalStatementEditing,secondaryStatementEditing, letterOfIntent, 
                 letterOfIntentPrice } = values;

          const consultationPrice = (parseFloat(consultationPriceHook)  * 1.25).toFixed(2);
          const brainstormPrice = (parseFloat(brainstormPriceHook)  * 1.25).toFixed(2);
          const mockPrice = (parseFloat(mockPriceHook)  * 1.25).toFixed(2);
          const personalStatementEditingPrice = (parseFloat(personalStatementEditingPriceHook) * 1.25).toFixed(2);
          const secondaryStatementEditingPrice = (parseFloat(secondaryStatementEditingPriceHook)  * 1.25).toFixed(2);

          const updateValues = {
            publicData: { service, brainstorm, mock, personalStatementEditing,secondaryStatementEditing, letterOfIntent, consultationPrice, brainstormPrice, mockPrice, personalStatementEditingPrice, secondaryStatementEditingPrice, letterOfIntentPrice },
          };

          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        serviceOptions={serviceOptions}
        mockOptions={mockOptions}
        brainstormOptions={brainstormOptions}
        personalStatementEditingOptions={personalStatementEditingOptions}
        secondaryStatementEditingOptions={secondaryStatementEditingOptions}
        letterOfIntentOptions={letterOfIntentOptions}
        listingData={listing}
        consultationPrice={consultationPriceHook}
        brainstormPrice={brainstormPriceHook}
        mockPrice={mockPriceHook}
        personalStatementEditingPrice={personalStatementEditingPriceHook}
        secondaryStatementEditingPrice={secondaryStatementEditingPriceHook}
        setConsultationPrice={setConsultationPrice}
        setBrainstormPrice={setBrainstormPrice}
        setMockPrice={setMockPrice}
        setPersonalStatementEditingPrice={setPersonalStatementEditingPrice}
        setSecondaryStatementEditingPrice={setSecondaryStatementEditingPrice}

      />
    </div>
  );
};

EditListingServiceInfoPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingServiceInfoPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingServiceInfoPanel;
